/**
 * Return true if the string contains at least one euro symbol
 * @param {string} string The string to check
 * @returns {boolean}
 */
export const doesContainEuroSymbol = (string: string) => {
  return new RegExp('\u20AC').test(string);
};
